<template>
  <div class="croppie-wrapper">
    <vue-croppie
      ref="croppieRef"
      :showZoomer="false"
      :mouseWheelZoom="'ctrl'"
      :enableResize="resize"
      :viewport="{ ...size, minWidth: 10, minHeight: 10, type: 'square' }"
    ></vue-croppie>
    <div class="info">
      {{ $t('info') }}
    </div>
    <div class="btn-wrapper">
      <Button class="croppie-crop-confirm" @click="crop" :label="$t('crop')" :buttonStyle="{ color: 'white' }" />
      <Button class="croppie-crop-cancel" @click="cancel" :label="$t('cancel')" :buttonStyle="{ color: 'white' }" />
    </div>
  </div>
</template>

<script>
import { infoAlert, successAlert, errorAlert } from '@/helpers/alertHelper.js'
import UploadFileService from '@/services/UploadFile.js'
import Button from '@/shared/components/Button'

export default {
  name: 'Croppie',
  components: { Button },
  i18nOptions: { keyPrefix: 'shared.croppie' },
  props: {
    image: {
      type: Object,
      default() {
        return {
          url: '',
        }
      },
    },
    resize: {
      type: Boolean,
      default: true,
    },
    full: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Object,
      default() {
        return {
          width: 200,
          height: 200,
        }
      },
    },
  },
  mounted() {
    if (this.full) {
      this.$refs.croppieRef.viewport.height = this.$el.clientHeight
      this.$refs.croppieRef.viewport.width = this.$el.clientWidth

      this.$refs.croppieRef.refresh()
    }

    this.$refs.croppieRef.bind({ url: this.image.url })
  },
  methods: {
    crop() {
      this.$refs.croppieRef.result({ type: 'blob', format: 'png' }, file => {
        file['name'] = 'cropped-image.png'
        infoAlert(this.$i18n.t('shared.croppie.upload-init'))

        UploadFileService.uploadCore(file)
          .then(response => {
            const url = response.data.data.uploadAsset.url
            this.$emit('crop', {
              url,
              ...this.$refs.croppieRef.get(),
            })
            successAlert(this.$i18n.t('shared.croppie.success'))
          })
          .catch(err => {
            console.error(err)
            errorAlert(this.$i18n.t('shared.croppie.error'))
          })
      })
    },
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="scss">
.croppie-wrapper {
  height: 80vh;
  max-width: 100%;
  position: relative;
  .croppie-container .cr-viewport {
    border: none;
  }
  .info {
    display: flex;
    justify-content: center;
    color: #7f7f80;
  }
  .btn-wrapper {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .button {
      width: auto;
      text-transform: uppercase;
      font-weight: 500;
      margin-right: 0px;
    }
    .croppie-crop-confirm {
      background-color: $cherry !important;
      border: 1.2px solid $cherry !important;
      &:hover {
        background: rgba($color: $cherry, $alpha: 0.9);
      }
      &:active {
        background: rgba($color: $cherry, $alpha: 0.8);
      }
    }
    .croppie-crop-cancel {
      background-color: #252632 !important;
      border: 1.2px solid #252632 !important;
      &:hover {
        background: rgba($color: #252632, $alpha: 0.9);
      }
      &:active {
        background: rgba($color: #252632, $alpha: 0.8);
      }
    }
  }
}
</style>
